export class DashboardMsgDateDto {
  dayWise: {
    [Key: string]: {
      openMsgCount: number;
      totalMsgCount: number;
    };
  };
  totalCount: number;
}
